import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/Chat.css";

function Chat() {
    return (
        <>
            <Header />
            <input type="hidden" id="profileImgChat" className="proImgChat" />
            <input type="hidden" id="giverId-Chat" className="giverId-Chat" />
            <input type="hidden" id="id" value="test" className="login-id" />
            <section>
                <div className="container-fluid">
                    <div className="row py-4">
                        <div className="col-md-12 pl-5">
                            <h4 className="blue">All Conversation</h4>
                            <p id="giver-bio">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. .
                            </p>
                        </div>
                    </div>
                </div>
                <div className="card rare-wind-gradient chat-room">
                    <div className="card-body">
                        {/* <!-- Grid row --> */}
                        <div className="row px-lg-2 px-2">
                            {/* <!-- Grid column --> */}
                            <div className="col-md-3 col-xl-3 px-0">
                                <div className="white z-depth-1 px-2 pt-3 pb-0 members-panel-1 scrollbar-light-blue">
                                    <ul className="list-unstyled friend-list border-bottom">
                                        <li className="active grey lighten-3 p-2">
                                            <a
                                                id="23"
                                                href="#;"
                                                className="d-flex justify-content-between chat-route"
                                            >
                                                <img
                                                    src="https://mdbootstrap.com/img/Photos/Avatars/avatar-8.jpg"
                                                    whidth="100"
                                                    height="100"
                                                    alt="avatar"
                                                    className="giver-picture avatar rounded-circle d-flex align-self-center mr-2 z-depth-1"
                                                />
                                                <div className="text-small pt-3">
                                                    <strong className="giverChat-name">
                                                        John Doe
                                                    </strong>
                                                    <p className="last-message text-muted ">
                                                        <span className="orange giver-service">
                                                            Senior Care
                                                        </span>
                                                        <br />
                                                        <span className="giver-country">
                                                            Manchester, England
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="chat-footer">
                                                    <p className="text-smaller text-muted mb-0">
                                                        <i className="fa fa-star"></i>{" "}
                                                        <span id="rating-by-customer">
                                                            4.5
                                                        </span>
                                                    </p>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {/* <!-- Grid column --> */}
                            <div className="col-md-9 col-xl-9 pl-md-3 px-lg-auto px-0">
                                <form id="chatStoreForm" method="" action="">
                                    <div className="chat-message">
                                        <ul className="list-unstyled chat-1 scrollbar-light-blue">
                                            <ul className="list-unstyled chat-1 scrollbar-light-blue provider-chat-messages"></ul>
                                            {/* <!--                                <li className="d-flex  justify-content-left mb-4">-->
                                    <!--                                    <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg" alt="avatar"-->
                                    <!--                                         className="avatar rounded-circle mr-2 ml-lg-3 ml-0 z-depth-1">-->
                                    <!--                                    <div className="chat-body white p-3 ml-2 z-depth-1">-->
                                    <!--                                        <p className="mb-0">-->
                                    <!--                                            Lorem ipsum dolor sit amet,-->
                                    <!--                                        </p>-->
                                    <!--                                        <div className="header">-->
                                    <!--                                            <strong className="primary-font">Brad Pitt</strong>-->
                                    <!--                                            <small className="pull-right text-muted"><i className="far fa-clock"></i> 12 mins-->
                                    <!--                                                ago</small>-->
                                    <!--                                        </div>-->
                                    <!--                                    </div>-->
                                    <!--                                </li>--> */}
                                            {/* <!--                                    <li className="d-flex justify-content-end mb-4" id="sender-msg">-->
<!--                                        <div id="all-customer-msgs" className="sender-chat chat-body white p-3 z-depth-1 d-none">-->
<!--                                            <p id="chat-message-result" className="mb-0 text-white blue-back chat-message-result">-->
<!--                                                test test-->
<!--                                            </p>-->
<!--                                            <div className="header ">-->
<!--                                                <strong className="primary-font">Lara Croft</strong>-->
<!--                                                <small className="pull-right text-muted"><i className="far fa-clock"></i> <span id="chat-message-time" className="chat-message-time">13 mins</span>-->
<!--                                                    ago</small>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-5.jpg" alt="avatar"-->
<!--                                             className="profile-pic avatar rounded-circle mr-0 ml-3 z-depth-1 d-none">-->
<!--                                    </li>--> */}
                                        </ul>
                                        <div className="white">
                                            <div className="d-flex justify-content-start">
                                                <div className="form-group basic-textarea col-md-9 col-xs-12 col-sm-12">
                                                    <input
                                                        type="hidden"
                                                        id="message_type"
                                                        value="text"
                                                        className="message_type"
                                                    />
                                                    <button className="send-chat">
                                                        <i
                                                            className="fa fa-paper-plane"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </button>
                                                    <textarea
                                                        className="form-control pl-2 my-0 chat-message"
                                                        id="giver-message"
                                                        rows="3"
                                                        placeholder="Type your message here..."
                                                        required
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="justify-content-end col-md-3 col-xs-12 col-sm-12">
                                <a
                                    id="hireNow-btn"
                                    href="#;"
                                    className="btn btn-secondary mr-2"
                                    data-toggle="modal"
                                    data-target="#hireFromChat"
                                >
                                    Submit Hiring Request
                                </a>
                                {/* <!--                                    <button type="button" className="btn btn-secondary btn-rounded btn-sm waves-effect waves-dark float-right">Submit Hiring Request</button>--> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Grid column --> */}
                {/* <!-- Modal --> */}
                <div
                    className="modal fade"
                    id="hireFromChat"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="hireFromChatTitle"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="col-md-12 d-flex mt-5">
                                    <div className="d-flex flex-column">
                                        <span className="d-flex">
                                            <h5 className="mt-2 mb-0 user-name">
                                                Create a custom offer
                                            </h5>
                                        </span>
                                        <p className="form-description">
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do
                                            eiusmod tempor incidid
                                        </p>
                                    </div>
                                    <div className="form-user-info">
                                        <p className="text-muted form-request">
                                            submitting requesting to
                                        </p>
                                        <div className="d-flex border form-user-details">
                                            <div className="profile-pic-section">
                                                <img
                                                    className="form-pic"
                                                    src="./img/team/profile-img.jpeg"
                                                />
                                            </div>
                                            <div className="d-flex flex-column">
                                                <p className="form-user-title color-red mb-0">
                                                    Consectetur
                                                </p>
                                                <p className="form-user-desc color-red mb-2">
                                                    Child Care
                                                </p>
                                            </div>
                                            <div className="form-rating-sec">
                                                <span className="fa fa-star star-active"></span>
                                                <span className="font-weight-bold ml-2 form-rating">
                                                    4.5
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="container">
                                    <form
                                        id="hiring-request"
                                        action=""
                                        method=""
                                    >
                                        {/* <!--Service--> */}
                                        <div className="d-flex">
                                            <h6 className="form-title mt-4">
                                                Choose Service
                                            </h6>
                                            <hr className="horizontal-line" />
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Choose main category
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <select
                                                    id="care-giver-category"
                                                    className="form-control select-form"
                                                >
                                                    <option className="giver-service">
                                                        Select from main
                                                        category
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Choose Sub category
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <select
                                                    id="care-giver-sub-service"
                                                    className="form-control select-form post-careGiver-subCategory"
                                                >
                                                    {/* <!--                                            <option>Select from sub category</option>--> */}
                                                </select>
                                            </div>
                                        </div>
                                        {/* <!--Pricing--> */}
                                        <div className="d-flex">
                                            <h6 className="form-title mt-4">
                                                Pricing
                                            </h6>
                                            {/* <hr className="horizontal-line"> */}
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                id="3"
                                                className="unit-type-hourly-lumsum form-check-input"
                                                type="radio"
                                                name="per-hour"
                                                id="inlineCheckbox1"
                                                value="3"
                                            />
                                            <label
                                                className="form-check-label checkbox-label"
                                                htmlFor="inlineCheckbox1"
                                            >
                                                Per Hour
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                id="6"
                                                className="unit-type-hourly-lumsum form-check-input"
                                                type="radio"
                                                name="per-hour"
                                                id="inlineCheckbox2"
                                                value="6"
                                            />
                                            <label
                                                className="form-check-label checkbox-label"
                                                htmlFor="inlineCheckbox2"
                                            >
                                                Lumspum
                                            </label>
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Add Amount
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <input
                                                    id="careGiver-amount"
                                                    type="text"
                                                    className="form-control select-form"
                                                    placeholder="Enter Amount Here"
                                                />
                                            </div>
                                        </div>
                                        {/* <!--Description--> */}
                                        <div className="d-flex">
                                            <h6 className="form-title mt-4">
                                                Description
                                            </h6>
                                            <hr className="horizontal-line" />
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Describe the task in detail
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <textarea
                                                    id="careGiver-note"
                                                    type="text"
                                                    className="form-control select-form"
                                                    placeholder="Max 500 words in Description"
                                                ></textarea>
                                            </div>
                                        </div>
                                        {/* <!--Service Period--> */}
                                        <div className="d-flex">
                                            <h6 className="form-title mt-4">
                                                Service Period
                                            </h6>
                                            <hr className="horizontal-line" />
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Select Date Range
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <input
                                                    id="careGiver-date"
                                                    type="date"
                                                    className="form-control select-form"
                                                    placeholder=""
                                                />
                                            </div>
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Select Time
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <input
                                                    id="careGiver-start-time"
                                                    type="time"
                                                    className="form-control select-form"
                                                    placeholder=""
                                                />
                                            </div>
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Status
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <select
                                                    id=""
                                                    className="careGiver-status form-control select-form"
                                                >
                                                    <option value="7">
                                                        Pending
                                                    </option>
                                                    <option value="10">
                                                        Scheduled
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-container mt-4">
                                            <div className="field-box">
                                                <label
                                                    htmlFor=""
                                                    className="col-form-label form-label"
                                                >
                                                    Address
                                                </label>
                                            </div>
                                            <div className="field-box ml-auto">
                                                <input
                                                    id="careGiver-address"
                                                    type="text"
                                                    className="form-control select-form"
                                                    placeholder=""
                                                />
                                            </div>
                                        </div>
                                        <p className="submit-info">
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt ut labore
                                            et dolore magna aliqua. Ut enim ad
                                            minim veniam, quis nostrud
                                            exercitation ullamco labo
                                        </p>
                                        {/* <!--Submit Button--> */}
                                        <div className="form-group row">
                                            <div className="col-sm-12">
                                                {/* <!--                                        <div className="form-check form-check-inline mt-3">-->
                                        <!--                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">-->
                                        <!--                                            <label className="form-check-label checkbox-label" htmlFor="inlineCheckbox1">I'm not a robot</label>-->
                                        <!--                                        </div>-->
                                        <!--                                        <a href="#;" className="btn btn-secondary float-right">Submit Hiring Request</a>--> */}
                                                <button className="btn btn-secondary float-right">
                                                    Submit Hiring Request
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default Chat;
